import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./css/Navbar.css";
import logoDark from "../images/logo-dark.png";
import logoLight from "../images/logo-light.png";
import LogoMain from "../images/logo.png";

const Navbar = ({ isDarkMode, toggleTheme }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    document.addEventListener("click", function (event) {
        let navbar = document.querySelector(".navbar-collapse");
        if (navbar.classList.contains("show")) {
            navbar.classList.remove("show");
        }
    });

    // Apply the theme class to the body
    useEffect(() => {
        document.body.className = isDarkMode ? "dark-theme" : "light-theme";
    }, [isDarkMode]);


    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
    });

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsModalOpen(true);
        }, 5000); // 5 seconds delay

        return () => clearTimeout(timer);
    }, []);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const [responseMessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        const formBody = new URLSearchParams(formData).toString();

        try {
            const response = await fetch("https://peracause.com/backend-files/per-a-cause/contact-per-a-cause.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formBody,
            });

            const result = await response.json();

            if (result.status === "success") {
                setResponseMessage("Message sent successfully! ✅");
                setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
            } else {
                setResponseMessage("Error: " + result.message);
            }
        } catch (error) {
            setResponseMessage("Error sending message. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {/* Show loading animation */}
            {/* Show loading animation */}
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-spinner"></div>
                    <p>Sending message...</p>
                </div>
            )}
            {/* Theme Toggle Button */}
            <div className="theme-button">
                <button className="btn btn-outline-secondary ms-3" onClick={toggleTheme}>
                    {isDarkMode ? <i className="fas fa-sun"></i> : <i className="fas fa-moon"></i>}
                </button>
            </div>

            {/* Navbar */}
            <nav className={`navbar navbar-expand-lg shadow-sm ${isDarkMode ? "navbar-dark bg-dark" : "navbar-light bg-light"}`}>
                <div className="container">
                    <Link to="/" className="navbar-brand">
                        <img src={LogoMain} alt="Logo" style={{ height: "50px" }} />
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={toggleMenu}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav mx-auto">
                            <li className="nav-item">
                                <NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} onClick={closeMenu} to="/">
                                    Home
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} onClick={closeMenu} to="/about">
                                    About Us
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} onClick={closeMenu} to="/services">
                                    Services
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} onClick={closeMenu} to="/portfolio">
                                    Portfolio
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} onClick={closeMenu} to="/blogs">
                                    Blogs
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} onClick={closeMenu} to="/contact">
                                    Contact Us
                                </NavLink>
                            </li>
                        </ul>

                        {/* Get Start Button */}
                        <div className="w-md-30 w-sm-50">
                            <div className="btn-container">
                                <a className="btn-content cursor-pointer" onClick={toggleModal}>
                                    <span className="btn-title">GET START</span>
                                    <span className="icon-arrow">
                                        <svg
                                            width="30px"
                                            height="30px"
                                            viewBox="0 0 66 43"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <path
                                                    id="arrow-icon-one"
                                                    d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                                                    fill="#FFFFFF"
                                                ></path>
                                                <path
                                                    id="arrow-icon-two"
                                                    d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                                                    fill="#FFFFFF"
                                                ></path>
                                                <path
                                                    id="arrow-icon-three"
                                                    d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                                                    fill="#FFFFFF"
                                                ></path>
                                            </g>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Modal with Overlay */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="">
                        <div className="">
                            <div className="modal-content">

                                <div class="contact-form-container p-4 rounded-4">
                                    <span className="close-button" onClick={toggleModal}>
                                        &times;
                                    </span>
                                    <form id="contactForm" action="contact.php" method="POST" className="p-3" onSubmit={handleSubmit}>
                                        <div class="row">
                                            <div class="col-md-6 mb-3">
                                                <input type="text" placeholder="First Name" class="form-control py-3 px-3 glass-background" id="firstName" name="firstName" onChange={handleChange} required />
                                            </div>
                                            <div class="col-md-6 mb-3">
                                                <input type="text" placeholder="Last Name" class="form-control py-3 px-3 glass-background" id="lastName" name="lastName" onChange={handleChange} required />
                                            </div>

                                        </div>

                                        <div class="row">
                                            <div class=" mb-3">
                                                <input type="tel" placeholder="Mobile Number" class="form-control py-3 px-3 glass-background" id="phone" name="phone" onChange={handleChange} required />
                                            </div>
                                            <div class=" mb-3">
                                                <input type="email" placeholder="Email Address" class="form-control py-3 px-3 glass-background" id="email" name="email" onChange={handleChange} required />
                                            </div>
                                            {/* <div class=" mb-3">
                      <input type="text" placeholder="Subject" class="form-control py-3 px-3 glass-background" id="subject" name="subject" required />
                    </div> */}
                                        </div>

                                        <div class="mb-3">
                                            <textarea class="form-control glass-background" placeholder="Message" id="message" name="message" rows="4" onChange={handleChange} required></textarea>
                                        </div>

                                        {/* <button type="submit" class="btn btn-primary">Submit</button> */}

                                        <div className="row justify-content-center">
                                            <div className="col-10">
                                                {/* From Uiverse.io by Li-Deheng */}
                                                <div className="btn-container my-3">
                                                    <button className="btn-content justify-content-center py-2 col-12 border-0" type="submit">
                                                        <span className="btn-title text-center">{loading ? "Sending..." : "SEND A MESSAGE"}</span>
                                                        <span className="icon-arrow">
                                                            <svg
                                                                width="30px"
                                                                height="30px"
                                                                viewBox="0 0 66 43"
                                                                version="1.1"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                    <path
                                                                        id="arrow-icon-one"
                                                                        d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                                                                        fill="#FFFFFF"
                                                                    ></path>
                                                                    <path
                                                                        id="arrow-icon-two"
                                                                        d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                                                                        fill="#FFFFFF"
                                                                    ></path>
                                                                    <path
                                                                        id="arrow-icon-three"
                                                                        d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                                                                        fill="#FFFFFF"
                                                                    ></path>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        {responseMessage && <p>{responseMessage}</p>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            )
            }
        </div >
    );
};

export default Navbar;
